import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getPatientDashboardAppointments } from 'api/Appointment';
import { getPatient } from 'api/Patients';

export const usePatient = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(['patient', params, ...dependencies], () => getPatient(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  });
};

export const usePatientDashboardAppointments = ({
  params = {},
  options = {},
  dependencies = []
}) => {
  const navigate = useNavigate();
  return useQuery(
    ['patient-dashboard-appointments', ...dependencies],
    () => getPatientDashboardAppointments(navigate, params),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: 5000,
      ...options
    }
  );
};
